<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-06 15:29:32
 * @FilePath: \YunYin_admin\src\views\Village\Log\List.vue
-->
<template>
  <LogList :dataSource="4"></LogList>
</template>

<script>
import LogList from "@/components/Query/LogList";
export default {
  name: "VillageLogList",
  data() {
    return {};
  },
  components: { LogList },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
